
















import { Component, Prop } from "vue-property-decorator";
import { DialogComponent } from "vue-modal-dialogs";

import ShippingManifestDestinationCorrectionForm from "./ShippingManifestDestinationCorrectionForm.vue";

import DistributionCenter from "../distribution-center.model";

@Component({
  components: { ShippingManifestDestinationCorrectionForm },
})
export default class ShippingManifestDestinationCorrectionPreviewDialog extends DialogComponent<boolean> {
  @Prop({ required: true })
  public readonly shippingManifestId!: string;

  @Prop({ required: true })
  public readonly currentDistributionCenterId!: string;

  @Prop({ required: true })
  public readonly distributionCenters!: DistributionCenter[];

  public closeDialog(): void {
    // eslint-disable-next-line vue/custom-event-name-casing
    this.$emit("vue-modal-dialogs:close", false);
  }

  public onSaved(): void {
    // eslint-disable-next-line vue/custom-event-name-casing
    this.$emit("vue-modal-dialogs:close", true);
  }
}
